function checkCountUp(target, count){
    const position = target.getBoundingClientRect();
    let timeout = 3000;
    let i = 0;
    let multiplicator = 1;

    if(count > 1000){
        timeout = 1000;
    }

    if(count > 100){
        multiplicator = 7
    }

    if(count > 1000){
        multiplicator = 50
    }

    if(count > 5000){
        multiplicator = 100
    }

    if((position.y > 0) && (position.y < window.outerHeight) && !target.classList.contains('counted')) {
        target.classList.add('counted');
        let inv = setInterval(function() {
            if(i < count) {
                i = i + multiplicator;
                if(i > count){
                    i = count;
                }
                target.innerHTML = i;
            }else{
                clearInterval(inv);
            }
        }, timeout / 100);
    }
}

export function countUp(target){
    let count = 0;

    if(target.dataset.countUp){
        count = parseInt(target.dataset.countUp);
    }

    window.addEventListener("load",function (e) {
        checkCountUp(target,count);
    });

    window.addEventListener("scroll",function (e) {
        checkCountUp(target,count);
    });

    window.addEventListener("orientationchange",function (e) {
        checkCountUp(target,count);
    });
}